<template>
  <div class="main-content pricing">  
    <div class="pricing-wrapper">
      <SbLoadingPromiseWrapper :loadingPromise="loadingPromise" :classes="loadingWrapperClasses">
        <pricing-details class="panel"></pricing-details>
      </SbLoadingPromiseWrapper>
    </div>
  </div>
</template>

<script>
import PricingDetails from './panels/PricingDetails'

export default {
  name: 'Pricing',
  components: {
    PricingDetails
  },
  data: () => ({
    loadingWrapperClasses: ['loading-wrapper']
  }),
  async mounted () {
    this.$shipBobStore.dispatch('pricing/setUpPricing')
  },
  computed: {
    loadingPromise () {
      return this.$shipBobStore.getters['pricing/loading']('inputs')
    }
  }
}
</script>

<style scoped lang='scss'>
.pricing {
  position: relative;
  background-color: #f9fafb;
  margin-top: 0;

  .pricing-wrapper {
    background-color: #f9fafb;

    .loading-wrapper {
      position: relative;
    }

    .panel {
      margin-bottom: 3em;

      &:last-of-type {
        margin-bottom: 0;
      }
    }
  }
}
</style>